"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RangeDateSelection = void 0;
var _react = require("react");
var _EnvironmentManager = require("../../EnvironmentManager.provider");
var _main = require("../../../../main");
var _EnvironmentManager2 = _interopRequireDefault(require("../../EnvironmentManager.styles"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const RangeDateSelection = props => {
  const {
    minDate,
    maxDate,
    startDate,
    endDate,
    isDisabled,
    onChange
  } = props;
  const {
    getLabel
  } = (0, _react.useContext)(_EnvironmentManager.EnvironmentManagerContext);
  const styles = (0, _EnvironmentManager2.default)();
  const [selectedDates, setSelectedDates] = (0, _react.useState)();
  (0, _react.useEffect)(() => {
    if (startDate && endDate) {
      setSelectedDates([startDate, endDate]);
    }
  }, [startDate, endDate]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: styles['cc-EnvironmentManager_Dates'],
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_main.RangeDatePicker, {
      view: "menu",
      anchorSubTextStart: getLabel('schedule_start_text'),
      startDate: (selectedDates && selectedDates[0]) ?? undefined,
      endDate: (selectedDates && selectedDates[1]) ?? undefined,
      minDate: minDate,
      maxDate: maxDate,
      attachedTo: 'StartDate',
      isDisabled: isDisabled,
      onChange: (startDateTime, endDateTime) => {
        if (startDateTime && selectedDates?.[1] && startDateTime > selectedDates[1]) {
          setSelectedDates([startDateTime, endDateTime ?? startDateTime]);
        } else {
          setSelectedDates([startDateTime, selectedDates?.[1]]);
        }
        if (startDateTime && endDateTime) {
          onChange(startDateTime, endDateTime ?? startDateTime);
        }
      }
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_main.RangeDatePicker, {
      view: "menu",
      anchorSubTextEnd: getLabel('schedule_end_text'),
      startDate: (selectedDates && selectedDates[0]) ?? undefined,
      endDate: (selectedDates && selectedDates[1]) ?? undefined,
      minDate: minDate,
      maxDate: maxDate,
      attachedTo: 'EndDate',
      isDisabled: isDisabled,
      onChange: (startDateTime, endDateTime) => {
        if (endDateTime && selectedDates?.[0] && endDateTime < selectedDates[0]) {
          setSelectedDates([startDateTime ?? endDateTime, endDateTime]);
        } else {
          setSelectedDates([selectedDates?.[0], endDateTime]);
        }
        if (startDateTime && endDateTime) {
          onChange(startDateTime ?? endDateTime, endDateTime);
        }
      }
    })]
  });
};
exports.RangeDateSelection = RangeDateSelection;